import React, { useState } from "react";
import "./LabDetailsPanel.css";
import EnquiryForm from "../EnquiryForm";

/* ── Budget label → SVG icon map ── */
const BUDGET_ICONS = {
  // Lab Setup variants
  "lab setup": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="11" width="16" height="7" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <rect x="5" y="7" width="10" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
      <rect x="8" y="3" width="4" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
      <line x1="10" y1="2" x2="10" y2="3" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  // Equipment / Kits variants
  "equipment": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="3.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.22 4.22l1.42 1.42M14.36 14.36l1.42 1.42M4.22 15.78l1.42-1.42M14.36 5.64l1.42-1.42" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  // Curriculum & Training
  "curriculum": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="14" height="14" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
      <line x1="6" y1="7" x2="14" y2="7" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="6" y1="10" x2="14" y2="10" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="6" y1="13" x2="10" y2="13" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  // Training (standalone)
  "training": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="14" height="14" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
      <line x1="6" y1="7" x2="14" y2="7" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="6" y1="10" x2="14" y2="10" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="6" y1="13" x2="10" y2="13" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  // Software & Digital Tools
  "software": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="4" width="16" height="11" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
      <line x1="7" y1="18" x2="13" y2="18" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="10" y1="15" x2="10" y2="18" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M6 8.5l2.5 2L6 12.5" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="10.5" y1="12.5" x2="14" y2="12.5" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  // Maintenance / Installation
  "maintenance": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 3.5a3 3 0 0 1 0 4.24l-8 8a3 3 0 1 1-4.24-4.24l8-8A3 3 0 0 1 14.5 3.5z" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="4.5" cy="15.5" r="1" fill="#0e2a5a"/>
    </svg>
  ),
  "installation": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 3.5a3 3 0 0 1 0 4.24l-8 8a3 3 0 1 1-4.24-4.24l8-8A3 3 0 0 1 14.5 3.5z" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="4.5" cy="15.5" r="1" fill="#0e2a5a"/>
    </svg>
  ),
  // Infrastructure
  "infrastructure": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="11" width="16" height="7" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <rect x="5" y="7" width="10" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
      <rect x="8" y="3" width="4" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
    </svg>
  ),
};

/* Picks the best icon by scanning the label for known keywords */
function getBudgetIcon(label) {
  const l = label.toLowerCase();
  if (l.includes("installation")) return BUDGET_ICONS["installation"];
  if (l.includes("maintenance"))  return BUDGET_ICONS["maintenance"];
  if (l.includes("software"))     return BUDGET_ICONS["software"];
  if (l.includes("curriculum"))   return BUDGET_ICONS["curriculum"];
  if (l.includes("training"))     return BUDGET_ICONS["training"];
  if (l.includes("infrastructure")) return BUDGET_ICONS["infrastructure"];
  if (l.includes("lab setup"))    return BUDGET_ICONS["lab setup"];
  if (l.includes("equipment") || l.includes("kits")) return BUDGET_ICONS["equipment"];
  // fallback — generic box
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="14" height="14" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
    </svg>
  );
}

export default function LabDetailsPanel({ lab, onBack, onClose }) {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showEnquiry, setShowEnquiry] = useState(false);

  const pkg = selectedPackage !== null ? lab.packages[selectedPackage] : null;

  /* ══════════════ PACKAGE DETAIL VIEW ══════════════ */
  if (pkg) {
    return (
      <>
        <div className="panel-wrapper">
          <div className="panel-header">
            <button className="back-btn" onClick={() => setSelectedPackage(null)}>
              ← Back to All Labs
            </button>
            <button className="close-btn" onClick={onClose}>✕</button>
          </div>

          <div className="pkg-detail-body">
            {/* LEFT — what it delivers */}
            <div className="pkg-detail-left">
              <div className="pkg-detail-section-label">
                <span className="pkg-detail-dot blue" />
                WHAT IT DELIVERS — {pkg.label.toUpperCase()}
              </div>
              <div className="pkg-detail-card">
                <div className="pkg-detail-card-header">
                  <span className="pkg-label-badge">{pkg.label.toUpperCase()}</span>
                  <div className="pkg-detail-card-title">
                    <h3>{lab.name} — {pkg.label} Setup</h3>
                    <p>Five Pillars of the School Innovation Program</p>
                  </div>
                  <button className="close-btn" onClick={onClose}>✕</button>
                </div>
                <div className="pkg-delivers-list">
                  {pkg.delivers?.map((item, i) => (
                    <div key={i} className="pkg-deliver-item">
                      <div className="pkg-deliver-icon">{item.icon}</div>
                      <div>
                        <strong>{item.title}</strong>
                        <p dangerouslySetInnerHTML={{ __html: item.desc }} />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="pkg-detail-footer">
                  <span className="footer-dot" />
                  <span>End-to-end implementation & support by iBots</span>
                  <button className="enquire-btn" onClick={() => setShowEnquiry(true)}>
                    ENQUIRE NOW →
                  </button>
                </div>
              </div>
            </div>

            {/* RIGHT — budget breakdown */}
            <div className="pkg-detail-right">
              <div className="pkg-detail-section-label">
                <span className="pkg-detail-dot blue" />
                {pkg.label.toUpperCase()} COST BREAKDOWN
              </div>
              <div className="pkg-budget-card">
                <div className="pkg-budget-header">
                  <span className="blue-dot-sm" />
                  <strong>BUDGET BREAKDOWN</strong>
                </div>

                {pkg.budget?.map((item, i) => (
                  <div key={i} className="pkg-budget-item">
                    <div className="pkg-budget-row">
                      <span className="pkg-budget-label">
                        <span className="pkg-budget-icon">
                          {getBudgetIcon(item.label)}
                        </span>
                        {item.label}
                      </span>
                      <span className="pkg-budget-percent">{item.percent}%</span>
                    </div>
                    <div className="pkg-bar-track">
                      <div
                        className={`pkg-bar ${item.color}`}
                        style={{ width: `${item.percent}%` }}
                      />
                    </div>
                  </div>
                ))}

                <div className="pkg-total-box">
                  <span>Total Investment — {pkg.label}</span>
                  <span className="pkg-total-price">{pkg.total}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showEnquiry && (
  <EnquiryForm
    labName={lab.name}
    labImage={lab.image}
    packageLabel={pkg.label}
    packagePrice={pkg.price}
    onClose={() => setShowEnquiry(false)}
  />
)}
      </>
    );
  }

  /* ══════════════ PACKAGE SELECT VIEW ══════════════ */
  return (
    <div className="panel-wrapper">
      <div className="panel-header">
        <button className="back-btn" onClick={onBack}>← Back to All Labs</button>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      <div className="panel-center">
        <div className="panel-left-card">
          <img src={lab.image} alt={lab.name} />
          <div className="panel-lab-info">
            <div className="panel-lab-title">
              <span>{lab.name}</span>
              <span className="arrow-up">∧</span>
            </div>
            <p className="domain-title">
              <span className="domain-icon">≡</span> DOMAINS INCLUDES
            </p>
            <div className="tags">
              {lab.domains?.map((d, i) => (
                <span key={i} className="tag">○ {d}</span>
              ))}
            </div>
            <button className="view-btn">
              <span className="view-btn-left">
                <span className="view-btn-icon">≡</span> VIEW PACKAGES
              </span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>

        <div className="panel-right">
          <div className="choose-row">
            <span className="choose-badge">🏷 CHOOSE YOUR PACKAGE</span>
            <span className="choose-hint">Select a plan to see what's included</span>
          </div>
          <div className="package-grid">
            {lab.packages?.map((p, i) => (
              <div
                key={i}
                className="package-card"
                onClick={() => setSelectedPackage(i)}
              >
                <div className="pkg-top">
                  <h4>{p.label}</h4>
                  <span className="pkg-arrow-circle">→</span>
                </div>
                <h2>{p.price}</h2>
                <span className="pkg-subtitle">{p.subtitle}</span>
                <div className="pkg-divider" />
                <div className="pkg-card-footer">
                  <span className="pkg-card-dot" />
                  Click to view details
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}